import { PopoverOrigin } from '@mui/material'
import { atom } from 'recoil'
import { keyFactory } from 'src/utils/recoil'

const key = keyFactory('user-lists-popover')

export const anchorElement = atom<HTMLElement | null>({
  key: key('anchor-element'),
  default: null,
})

export const position = atom<PopoverOrigin>({
  key: key('position'),
  default: {
    vertical: 32,
    horizontal: 0,
  },
})
